import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/awarenessInstructions.css";
import useTranslation from "../hooks/useTranslation";

function AwarenessInstructions({ gameData, updateProgress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handlePlay = () => {
    updateProgress('awareness');
    console.log('Iniciando Awareness con datos:', gameData);
    navigate('/game/awareness');
  };

  return (
    <div className="awareness-container">
      {/* Contenido central */}
      <div className="awareness-content">
        <div className="awareness-header">
          <h1 className="game-title">{t('awarenessInstructions.gameTitle')}</h1>
          <h2 className="game-subtitle">{t('awarenessInstructions.gameSubtitle')}</h2>
        </div>

        <div className="instructions-box">
          <h2 className="instructions-title">{t('awarenessInstructions.title')}</h2>
          <h3 className="instructions-subtitle">{t('awarenessInstructions.subtitle')}</h3>
          
          <div className="instructions-text">
            <p>
            {t('awarenessInstructions.welcomeMessage')}
            </p>

            <p>
            {t('awarenessInstructions.paragraph1')}
            </p>
            
            <p>
            {t('awarenessInstructions.paragraph2')}
            </p>
            
            <p>
              {t('awarenessInstructions.paragraph3')}
            </p>
          </div>

          <div className="buttons-container">
            <button className="play-button" onClick={handlePlay}>
              {t('awarenessInstructions.playButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AwarenessInstructions;

